import { getCurrentInstance, computed } from "vue";
import slugify from "./component-library75.mjs";
const getFiltersProps = (props, blacklist) => {
  const filteredProps = {};
  Object.keys(props).forEach((propName) => {
    if (blacklist.includes(propName))
      return;
    filteredProps[propName] = props[propName];
  });
  return filteredProps;
};
function useLabeledInput(props, emits) {
  const instance = getCurrentInstance();
  const inputId = computed(() => {
    var _a, _b;
    const tag = (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$options) == null ? void 0 : _b._componentTag;
    const idPrefix = props.idPrefix ? `${props.idPrefix}-` : "";
    const id = props.id || // @ts-ignore
    [tag, slugify(`${idPrefix}${props.label || props.name || ""}`)].filter(Boolean).join("-");
    if (!id) {
      console.error('Input has no id. Enter a prop "id"', tag);
    }
    return id;
  });
  const inputWrapperProps = computed(() => ({
    id: inputId.value,
    errorMessage: props.errorMessage,
    readonly: props.readonly,
    disabled: props.disabled,
    required: props.required,
    label: props.label,
    labelClass: props.labelClass,
    large: props.large,
    value: props.value,
    hasFixedValue: props.hasFixedValue
  }));
  const inputFiledProps = computed(() => ({
    ...getFiltersProps(props, [
      "label",
      "errorMessage",
      "class",
      "inputProps",
      "options",
      "idPrefix"
    ]),
    ...props.inputProps || {}
  }));
  const primaryInput = computed(() => {
    var _a, _b;
    return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs) == null ? void 0 : _b.primaryInput;
  });
  return {
    primaryInput,
    inputId,
    inputWrapperProps,
    inputFiledProps,
    onInput: (event) => {
      const target = event == null ? void 0 : event.target;
      if (emits) {
        emits("input", target == null ? void 0 : target.value);
      }
    },
    focus: () => {
      if (!primaryInput.value)
        throw new Error("Input does not support focus");
      primaryInput.value.focus();
      if (emits) {
        emits("focus");
      }
    }
  };
}
export {
  useLabeledInput
};
